










import { Component, Mixins } from "vue-property-decorator";
import ProductsMixin from "@/mixins/http/ProductsMixin";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "../../store/types/RequestData";

import { ProductPayload } from "../../models/Product";
import { showToast } from "../../utils/Toast";
import ProductForm from "@/components/Product/Form.vue";

const tag = "create_product";

@Component({
  components: {
    ProductForm,
  },
})
export default class ProductCreate extends Mixins(ProductsMixin) {
  @RegisterHttp(tag) readonly createProductRequest: RequestData;

  product: ProductPayload = Object.assign(new ProductPayload(), { price: 0 });

  get loading() {
    return this.createProductRequest?.loading;
  }

  get requestTag() {
    return tag;
  }

  back() {
    this.$router.go(-1);
  }

  onCreate(formData: ProductPayload) {
    this.createProduct(formData, tag).then(
      () => {
        showToast("Product created successfully!");
        this.back();
      },
      (err) => {
        if (err?.response?.status === 422) {
          showToast("Could not save product", {
            type: "error",
          });
        } else {
          showToast(
            "An error occurred while updating the product: " + err.message,
            {
              type: "error",
            }
          );
        }
      }
    );
  }

  mounted() {
    let query = { ...this.$route.query };
    this.product.family_id = query.familyId as string;
    delete query.familyId;
  }
}
